import React, { useEffect, useRef, useState } from 'react';

interface WordRevealProps {
  text: string;
  className?: string;
  stagger?: number; // milissegundos entre cada palavra
  delay?: number;   // atraso inicial total
}

const WordReveal: React.FC<WordRevealProps> = ({ 
  text, 
  className = "", 
  stagger = 40, 
  delay = 0 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  
  // Divide o texto em palavras, mantendo espaços
  const words = text.split(' ');

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (containerRef.current) observer.unobserve(containerRef.current);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div ref={containerRef} className={`${className} flex flex-wrap`}>
      {words.map((word, i) => (
        <span
          key={i}
          className={`reveal-on-scroll inline-block mr-[0.25em] ${isVisible ? 'is-visible' : ''}`}
          style={{ 
            animationDelay: `${delay + (i * stagger)}ms`,
            // Garante que o span não quebre o layout mas permita transformações
            whiteSpace: 'pre'
          }}
        >
          {word === "" ? "\u00A0" : word}
        </span>
      ))}
    </div>
  );
};

export default WordReveal;